import { render, staticRenderFns } from "./healthManual.vue?vue&type=template&id=27e1a71e&scoped=true&"
import script from "./healthManual.vue?vue&type=script&lang=js&"
export * from "./healthManual.vue?vue&type=script&lang=js&"
import style0 from "./healthManual.vue?vue&type=style&index=0&id=27e1a71e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27e1a71e",
  null
  
)

export default component.exports